var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contentContainer"},[_c('SpinnerReactor',{directives:[{name:"show",rawName:"v-show",value:(_vm.loader),expression:"loader"}]}),_c('iframe',{attrs:{"title":"Reporte_Externo_OSS","width":"100%","height":"100%","src":_vm.userLogged.report_url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }